import { render, staticRenderFns } from "./newPassword.vue?vue&type=template&id=bf50915a&scoped=true"
import script from "./newPassword.vue?vue&type=script&lang=js"
export * from "./newPassword.vue?vue&type=script&lang=js"
import style0 from "./newPassword.vue?vue&type=style&index=0&id=bf50915a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf50915a",
  null
  
)

export default component.exports